import { __ } from "@jti/fe-common";
import { AGE_VERIFICATION_STEP } from "../../constants";
const getAgeVerificationTabTitle = (isAgeEnabled, isAgeOptional) => {
    if (isAgeEnabled && isAgeOptional) {
        return `${__("auth.age_verification.title")} ${__("auth.registration.title_step_optional")}`;
    }
    return __("auth.age_verification.title");
};
export const getRegistrationSteps = ({ isDeviceRegistrationEnabled, isAgeEnabled, isAgeOptional, isSocialFlow, isAgeVerificationEnabled, isDeviceRegistrationMandatory = false, isReferralOn, }) => {
    const titles = [];
    const steps = [];
    if (isSocialFlow && isReferralOn) {
        titles.push({ title: __("auth.registration.referral_code.step_title"), canAccessPrev: false });
        steps.push({ index: 1, component: "ReferralCode" });
    }
    if (!isSocialFlow) {
        titles.push({ title: __("auth.registration.login_credentials.title"), canAccessPrev: true }, { title: __("auth.registration.personal_details.title"), canAccessPrev: true });
        steps.push({ index: 1, component: "LoginCredential" }, { index: 2, component: "PersonalDetailsPage" });
    }
    if (isAgeVerificationEnabled && !isSocialFlow) {
        titles.push({ title: getAgeVerificationTabTitle(isAgeEnabled, isAgeOptional), canAccessPrev: true });
        steps.push({ index: AGE_VERIFICATION_STEP, component: "AgeVerification" });
    }
    if (isDeviceRegistrationEnabled) {
        titles.push({
            title: isDeviceRegistrationMandatory
                ? __("auth.registration.device.title_mandatory")
                : __("auth.registration.device.title"),
            canAccessPrev: false,
        });
        steps.push({ index: 4, component: "DeviceRegistration" });
    }
    return { steps, titles };
};
